"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.event = exports.pageView = void 0;
var pageView_1 = require("./pageView");
Object.defineProperty(exports, "pageView", { enumerable: true, get: function () { return pageView_1.pageView; } });
var event_1 = require("./event");
Object.defineProperty(exports, "event", { enumerable: true, get: function () { return event_1.event; } });
//# sourceMappingURL=index.js.map